import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import logger from "redux-logger";
import reducers from "../reducers";
import { axiosAuthInstance } from "../../utilities/configureAuthAxios";
import { axiosReportInstance } from "../../utilities/configureReportAxios";

const persistConfig = {
  key: "auto vend",
  storage,
  timeout: null,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: {
          apiAuth: axiosAuthInstance,
          apiReport: axiosReportInstance,
        },
      },
    }).concat(logger),
  devTools: process.env.NODE_ENV !== "production",
});

const persistor = persistStore(store);

export { store, persistor };
